module.exports = __webpack_public_path__ + "img/quinton.5edfb24b.svg";